/*
 * IMPORTS
 */
import React from "react"; // Npm: react.js library.
import PropTypes from "prop-types"; // Npm: React prop types.
import { connect } from "react-redux"; // Npm: React Redux.
import { useHistory } from "react-router-dom"; // Npm: React router dom.
import { HiPencil, HiTrash } from "react-icons/hi2"; // Npm: React icons.
import { IconButton, Menu, MenuItem } from "@mui/material"; // Npm: Material UI components.

/*
 * OBJECTS
 */
const Index = ({
  scriptId,
  scriptName,
  onScriptDelete,
  PassOnUpdate,
}) => {
  // Hook assignment.
  const [_anchorEl, _setAnchorEl] = React.useState(null);
  const _historyRef = useHistory();
  const _open = Boolean(_anchorEl);

  // Event handler.
  const _HandleClose = () => _setAnchorEl(null);

  // Return component.
  return (
    <>
      <IconButton
        aria-label="PDU script actions"
        onClick={(event) => _setAnchorEl(event.currentTarget)}
        sx={{
          margin: "auto",
          borderRadius: "8px",
          color: "gray.500",
          backgroundColor: "transparent",
        }}
      >
        <HiPencil size={18} />
      </IconButton>
      <Menu
        anchorEl={_anchorEl}
        open={_open}
        onClose={_HandleClose}
        anchorOrigin={{ vertical: "top", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MenuItem
          onClick={() => {
            PassOnUpdate({ scriptId, scriptName });
            _historyRef.push(`/pdu-script/edit/${scriptId}`);
            _HandleClose();
          }}
        >
          <HiPencil size={18} />
          <span>Edit Script</span>
        </MenuItem>
        <MenuItem
          onClick={() => {
            PassOnUpdate({ scriptId, scriptName });
            onScriptDelete();
            _HandleClose();
          }}
        >
          <HiTrash size={18} />
          <span>Delete Script</span>
        </MenuItem>
      </Menu>
    </>
  );
};

/*
 * PROPTYPES
 */
Index.propTypes = {
  scriptId: PropTypes.string,
  scriptName: PropTypes.string,
  onScriptDelete: PropTypes.func,
  PassOnUpdate: PropTypes.func,
};

/*
 * REDUX
 */
const _MapDispatchToProps = (__dispatch) => ({
  PassOnUpdate: (value) =>
    __dispatch({ type: "PASS_ON_UPDATE", PassOn: value }),
});

/*
 * EXPORT
 */
export default connect(void 0, _MapDispatchToProps)(Index);
